module.exports = __webpack_public_path__ + "images/head.9efe293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/home/head.png
// module id = YpF/
// module chunks = 19